import { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { isHTTPError, isNetworkError } from '../../common/utils';
import { type ExtraErrorAttributes } from '../../common/utils/types';
import { useGlobalContextActions } from '../index';

export function shouldReportError(error: unknown): boolean {
	if (!isNetworkError(error)) {
		return true;
	}

	return !isHTTPError(error);
}

export type ReportError = (
	id: string,
	error: unknown,
	attributes?: ExtraErrorAttributes,
	teamName?: string,
) => void;

export const useReportError = (): ReportError => {
	const { reporterAction } = useGlobalContextActions();

	return useMemo(
		() => (id, error, attributes, teamName) => {
			if (!shouldReportError(error)) {
				return;
			}

			if (fg('eoc_fix_error_reporting')) {
				reporterAction({ id, error, attributes, teamName });
			} else {
				reporterAction({ id, error, attributes });
			}
		},
		[reporterAction],
	);
};
